const PARTNER_TAG = "mytassel03-20";
const AMAZON_URL_MARKERS = ["amazon.com", "amzn.to", "a.co"];

const isAmazonUrl = (url) => AMAZON_URL_MARKERS.some((marker) => url.includes(marker));

/** Makes sure Amazon links carry MyTassel's affiliate tag. Other links are returned untouched. */
export const ensureAffiliateTag = (url) => {
	if (!url || typeof url !== "string" || !isAmazonUrl(url)) return url;
	if (!url.includes("?")) return `${url}?tag=${PARTNER_TAG}`;
	if (url.includes("tag=")) return url.replace(/tag=[^&]*/, `tag=${PARTNER_TAG}`);
	return `${url}&tag=${PARTNER_TAG}`;
};

/** A catalogue product in the shape the Registry stores it: with the affiliate tag on its link. */
export const toRegistryCandidate = (item) => ({
	...item,
	url: ensureAffiliateTag(item.url || item.affiliateUrl),
});
